<template>
  <div>
    <div class="login-container">
      <loading v-if="isLoading" />
      <div v-else>
        <div>
          <img class="logo" :src="logo" />
          <div v-show="version" class="version">Version {{version}}</div>
          <div class="has-text-primary margin-top-2 is-size-5">Password Reset</div>
        </div>

        <form class="login-form" autocomplete="off" @submit.prevent="submit">
          <div class="field">
            <label class="label is-sr-only">New Password</label>
            <div class="control has-icons-left">
              <input class="input" :class="{'is-danger' : $v.resetPasswordData.$dirty && $v.resetPasswordData.newPassword.$error}" type="password" placeholder="New Password" v-model="$v.resetPasswordData.newPassword.$model" />
              <span class="icon is-medium is-left">
                <fa-icon :icon="faLock" />
              </span>
            </div>
            <div class="help is-danger" v-if="$v.resetPasswordData.$dirty && !$v.resetPasswordData.newPassword.required">{{$v.resetPasswordData.newPassword.$params.required.msg}}</div>
            <div class="help is-danger" v-if="$v.resetPasswordData.$dirty && !$v.resetPasswordData.newPassword.minLength">{{$v.resetPasswordData.newPassword.$params.minLength.msg}}</div>
            <div class="help is-danger" v-if="$v.resetPasswordData.$dirty && !$v.resetPasswordData.newPassword.regex">{{$v.resetPasswordData.newPassword.$params.regex.msg}}</div>
          </div>

          <div class="field">
            <label class="label is-sr-only">Confirm New Password</label>
            <div class="control has-icons-left">
              <input class="input" :class="{'is-danger' : $v.resetPasswordData.$dirty && $v.resetPasswordData.confirmNewPassword.$error}" type="password" placeholder="Confirm New Password" v-model="$v.resetPasswordData.confirmNewPassword.$model" />
              <span class="icon is-medium is-left">
                <fa-icon :icon="faLock" />
              </span>
            </div>
            <div class="help is-danger" v-if="$v.resetPasswordData.$dirty && !$v.resetPasswordData.confirmNewPassword.required">{{$v.resetPasswordData.confirmNewPassword.$params.required.msg}}</div>
            <div class="help is-danger" v-if="$v.resetPasswordData.$dirty && !$v.resetPasswordData.confirmNewPassword.sameAs">{{$v.resetPasswordData.confirmNewPassword.$params.sameAs.msg}}</div>
          </div>

          <div class="field">
            <button type="submit" class="button is-primary is-pulled-right">Reset</button>
            <div class="copyright">{{copyrightText}}</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { VERSION } from "@/stores/application/getters"
import logo from "@/assets/logo-grey.png"
import { withParams } from 'vuelidate';
import { required, sameAs, minLength } from "vuelidate/lib/validators"
import loading from "@/components/loading"
import { faUser, faLock } from "@fortawesome/free-solid-svg-icons"

export default {
  components: {
    loading
  },
  data() {
    return {
      logo,
      isLoading: false,
      resetPasswordData: {
        username: this.$route.query.username,
        token: this.$route.query.token,
        newPassword: "",
        confirmNewPassword: ""
      },
      copyrightText: "© Warners Group Publications Plc 2020",
      faUser,
      faLock
    }
  },
  computed: {
    ...mapGetters({
      version: VERSION
    })
  },
  methods: {
    submit() {
      this.$v.resetPasswordData.$touch()

      if (this.$v.resetPasswordData.$invalid)
        return

      this.isLoading = true

      this.$http.post("authentication/password-reset", this.resetPasswordData).then(() => {
        this.$alert("Your password was successfully reset.", "", "success");
        this.$router.push("/login");
      }).catch((error) => {
        if (error.response.data) {
          this.$alert(error.response.data, "", "error");
        } else this.$alert("An unexpected error occurred resetting your password. Please try again.", "", "error");

        this.isLoading = false
      });
    },
  },
  created() {
    if (!this.$route.query.username || !this.$route.query.token) {
      this.$router.push("/login");
    }
  },
  validations: {
    resetPasswordData: {
      username: { required },
      token: { required },
      newPassword: {
        required: withParams({ msg: "Please enter your new password." }, required),
        minLength: withParams({ msg: "Your password must be at least 6 characters in length." }, minLength(6)),
        regex: withParams({ msg: "Your password must contain at least 1 digit, 1 uppercase character and 1 lowercase character." }, function (value) {
          var pattern = new RegExp("(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])");
          return pattern.test(value);
        })
      },
      confirmNewPassword: {
        required: withParams({ msg: "Please confirm your new password." }, required),
        sameAs: withParams({ msg: "The two passwords do not match." }, sameAs('newPassword'))
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.login-container
  text-align: center
  align-items: center
  position: absolute
  width: 320px
  height: 450px
  top: 50%
  left: 50%
  margin-top: -225px
  margin-left: -160px
.login-form
  padding: 15px
  text-align: left
.logo
  width: 150px
.version
  margin-top: -10px
  font-size: 14px
.copyright
  text-align: center
  font-size: 12px
  display: inline-block
  margin-top: 15px
.button
  margin-top: 7px
</style>